import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { useState, useEffect, FC } from 'react';
import { TSummarySpec, TSummarySpecsProps } from '../../types/modelsListing.types';

const SummarySpecs: FC<TSummarySpecsProps> = ({ summarySpecs }) => {
  const [localSummarySpecs, setLocalSummarySpecs] = useState<TSummarySpec[]>([]);

  useEffect(() => {
    if (summarySpecs?.length > 0) {
      const specs = summarySpecs.slice(0, 4);
      setLocalSummarySpecs(specs);
    }
  }, [summarySpecs]);

  return (
    <ul className="product-card__summary-specs">
      {localSummarySpecs.map((spec, index) => (
        <React.Fragment key={`summary-spec-${index}`}>
          {spec?.key && spec?.value && (
            <li className="product-card__summary-specs-item">
              <RichText
                tag="div"
                className="product-card__summary-specs-headline rich-text"
                field={{ value: spec?.key }}
                editable={false}
              />
              <RichText tag="div" className="product-card__summary-specs-value rich-text" field={{ value: spec?.value }} editable={false} />
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default SummarySpecs;
